export default {
  title: 'Espaces de travail',
  description: 'Vous pouvez voir ci-dessous tout vos espaces de travail. Sélectionnez celui qui vous intéresse pour passer à la suite.'
}

//   description: 'Below you can see all your workspace to which you belong. Select one tha interests you and have a peek at the details'



// WEBPACK FOOTER //
// ./src/translations/fr/workspace.js